import { render, staticRenderFns } from "./AllAddons.vue?vue&type=template&id=8b81f13e&scoped=true"
import script from "./AllAddons.vue?vue&type=script&lang=js"
export * from "./AllAddons.vue?vue&type=script&lang=js"
import style0 from "./AllAddons.vue?vue&type=style&index=0&id=8b81f13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b81f13e",
  null
  
)

export default component.exports